/** Textos da secção "simulator". Chaves planas "simulator.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    // Cabeçalho / hero
    "simulator.back": "← Voltar aos planos VIP",
    "simulator.headerSub": "Simulador VIP personalizado",
    "simulator.title": "Monta o teu VIP [BETA]",
    "simulator.lead.p1":
        "Monta o kit em grelha estilo Rust: inventário, cinto e equipamento. Clica nos itens para adicionar; arrasta no kit para reorganizar. Nas armas, ",
    "simulator.lead.mods": "Mods",
    "simulator.lead.or": " ou ",
    "simulator.lead.dblClick": "duplo-clique",
    "simulator.lead.p2": " abre a vista 3D para equipar acessórios. Remove só com ",
    "simulator.lead.p3": ". O preço final continua ",
    "simulator.lead.negotiable": "negociável com os admins",
    "simulator.lead.end": ".",
    "simulator.minNotice.strong": "VIP personalizado a partir de {amount}.",
    "simulator.minNotice.text": " Só aceitamos pedidos com total estimado do kit igual ou superior a este valor.",
    "simulator.nameLabel": "Nome do VIP",
    "simulator.namePlaceholder": "ex.: VIP Raid Night",

    // Abas
    "simulator.tabs.aria": "Secção do simulador",
    "simulator.tabs.kit": "Kit",
    "simulator.tabs.benefits": "Benefícios",

    // Workspace
    "simulator.workspace.title": "Workspace",
    "simulator.workspace.lead1":
        "Cinto (armas e consumíveis), inventário 6×4 e equipamento. Clica para adicionar; em armas usa ",
    "simulator.workspace.lead2": " ou duplo-clique para acessórios (modelo 3D no MP5 e AK).",
    "simulator.belt.aria": "Cinto",
    "simulator.belt.title": "Cinto (belt)",
    "simulator.belt.meta": "6 slots",
    "simulator.inv.aria": "Inventário",
    "simulator.inv.title": "Inventário",
    "simulator.inv.meta": "6 × 4 slots",
    "simulator.equip.aria": "Roupa e armadura",
    "simulator.equip.title": "Roupa + armadura",
    "simulator.equip.meta": "Equipável",
    "simulator.armor.gridAria": "Equipável — 7 slots estilo Rust",

    // Slots de equipamento (acessibilidade)
    "simulator.armorSlot.armor-head": "Cabeça",
    "simulator.armorSlot.armor-mask": "Máscara",
    "simulator.armorSlot.armor-chest": "Tronco",
    "simulator.armorSlot.armor-belt": "Cintura",
    "simulator.armorSlot.armor-hands": "Mãos",
    "simulator.armorSlot.armor-legs": "Pernas",
    "simulator.armorSlot.armor-feet": "Pés",
    "simulator.armorSlot.default": "Equipável",

    // Categorias (pasta → rótulo); em PT o rótulo é a própria chave
    "simulator.categories": {},

    // Itens disponíveis
    "simulator.pool.all": "Todos",
    "simulator.pool.title": "Itens disponíveis",
    "simulator.pool.hint":
        "A lista permanece sempre visível. Ajusta a quantidade antes de adicionar; se o item já estiver no kit, a quantidade é somada no mesmo slot (com confirmação). Com a arma no kit, duplo-clique nela para equipar acessórios.",
    "simulator.pool.catsAria": "Categorias de itens",
    "simulator.pool.emptyCatalog": "Nenhum item no catálogo desta categoria.",
    "simulator.pool.emptyCategory": "Não há itens nesta categoria. Escolhe outra ou volta a \"Todos\".",

    // Cartão de item
    "simulator.item.addTitleQty": "Adicionar {name} ao kit (ou somar quantidade se já existir)",
    "simulator.item.addTitle": "Adicionar {name} ao kit",
    "simulator.item.unit": "Unit.: {price}",
    "simulator.item.noPrice": "Sem preço definido",
    "simulator.item.wearable": "Equipável",
    "simulator.item.outfitNote": "Inventário ou tronco (Equipável)",
    "simulator.item.qty": "Qtd: {qty}",
    "simulator.item.sub": "Sub: {amount}",
    "simulator.item.remove": "Remover do kit",

    // Stepper
    "simulator.stepper.decrease": "Diminuir",
    "simulator.stepper.quantity": "Quantidade",
    "simulator.stepper.increase": "Aumentar",

    // Equipamento rápido
    "simulator.quick.aria": "Equipamentos rápidos",
    "simulator.quick.label": "Equipamento rápido",
    "simulator.quick.title": "Vestir conjunto: {label}",

    // Armas / acessórios
    "simulator.weapon.hint": "{name} — duplo-clique ou botão Mods para acessórios",
    "simulator.weapon.modsAria": "Acessórios em {name}",
    "simulator.weapon.modsTitle": "Equipar acessórios (mira, cano, laser, carregador)",
    "simulator.weapon.mods": "Mods",
    "simulator.weapon.hasMods": "Com acessórios",
    "simulator.wmod.slot.sight": "Mira",
    "simulator.wmod.slot.barrel": "Cano",
    "simulator.wmod.slot.laser": "Laser",
    "simulator.wmod.slot.magazine": "Carregador",
    "simulator.wmod.poolEquippedTitle": "{name} — remove só desta arma (continua na lista)",
    "simulator.wmod.poolEquipTitle": "Equipar {name} nesta arma (a lista não perde o item)",
    "simulator.wmod.equippedBadge": "Equipado",
    "simulator.wmod.slotFilledTitle": "{name} — clique para remover",
    "simulator.wmod.slotEmptyTitle": "Slot {slot} vazio",
    "simulator.wmod.desc3d": "Modelo 3D ({title}). Roda e amplia; clica num acessório para equipar ou remover.",
    "simulator.wmod.descNo3d":
        "Sem animação 3D para esta arma — usa o ícone. Clica num acessório para equipar ou remover.",
    "simulator.wmod.equipped": "Equipado",
    "simulator.wmod.poolTitle": "Acessórios (itens de armas)",
    "simulator.wmod.poolHint": "A lista não esvazia ao equipar — podes usar o mesmo acessório noutra arma depois.",
    "simulator.wmod.poolEmpty":
        "Não há acessórios compatíveis na lista. Adiciona miras, silenciadores, laser ou carregador na categoria Armas.",

    // Resumo
    "simulator.summary.aria": "Resumo do pedido",
    "simulator.summary.title": "Resumo",
    "simulator.summary.vipName": "Nome do VIP",
    "simulator.summary.budget": "Budget (simulação)",
    "simulator.summary.budgetWarn": "Patamar acima do total — adiciona itens ao kit para fechar o valor.",
    "simulator.summary.inv": "Inventário",
    "simulator.summary.belt": "Cinto",
    "simulator.summary.gear": "Equipamento",
    "simulator.summary.itemsCount": "{count} itens",
    "simulator.summary.piecesCount": "{count} peças",
    "simulator.summary.invoiceItems": "Itens da fatura",
    "simulator.summary.colName": "Nome",
    "simulator.summary.colQty": "Qtd.",
    "simulator.summary.colUnit": "Valor/qtd.",
    "simulator.summary.colSub": "Subtotal",
    "simulator.summary.noItems": "Nenhum item selecionado",
    "simulator.summary.benefits": "Benefícios selecionados",
    "simulator.summary.none": "Nenhum",
    "simulator.summary.extras": "Extras (benefícios)",
    "simulator.summary.total": "Total estimado",
    "simulator.summary.kitPlusBenefits": "Kit {kit} + benefícios {extras}",
    "simulator.summary.budgetLine": "Budget (simulação): R$ {budget}",
    "simulator.summary.budgetBelow": " — patamar abaixo do total do kit",
    "simulator.summary.missingMin": "Faltam {amount} para o mínimo de {min}",
    "simulator.summary.finalPrice": "Preço final: ",
    "simulator.summary.negotiable": "Negociável com admins",
    "simulator.summary.download": "Baixar fatura",
    "simulator.summary.toDownload": "Para baixar a fatura:",
    "simulator.summary.needName1": "Preenche o ",
    "simulator.summary.needName2": "nome do VIP",
    "simulator.summary.needName3": " no topo da página (obrigatório).",
    "simulator.summary.needMin1": "O total do kit deve ser pelo menos ",
    "simulator.summary.needMin2": " (faltam {amount}).",
    "simulator.summary.tierNote":
        "O patamar de budget (R$ {budget}) pode ser diferente do total — isso não bloqueia a fatura.",
    "simulator.summary.hint1": "A ",
    "simulator.summary.hintInvoice": "fatura",
    "simulator.summary.hint2": " é descarregada no teu computador. Depois abre um ticket na categoria ",
    "simulator.summary.hintVips": "VIPs",
    "simulator.summary.hint3": " no Discord e anexa o ficheiro.",
    "simulator.summary.success":
        "Fatura guardada. Abre o Discord, cria ticket VIP e envia o ficheiro para os admins analisarem o teu kit.",
    "simulator.summary.attachmentSuffix": "{name} (acessório)",

    // Botão Discord
    "simulator.discord.aria": "Abrir Discord ZRS e criar ticket na categoria VIPs",
    "simulator.discord.label": "Abrir ticket VIP no Discord",
    "simulator.discord.sub": "Envia a fatura que acabaste de descarregar",

    // Toasts / confirmações
    "simulator.toast.presetNotFound": "Conjunto de equipamento não encontrado.",
    "simulator.toast.presetMissing": "Equipamento aplicado, mas faltam itens no catálogo: {items}",
    "simulator.toast.presetApplied": "Equipamento rápido aplicado nos 7 slots.",
    "simulator.confirm.merge":
        "Já tens \"{name}\" no kit (×{qty}).\n\nAo adicionar, a quantidade no inventário passa para ×{newQty} — não ocupa outro slot.\n\nContinuar?",
    "simulator.toast.onlyAttachments": "Só acessórios de arma podem ser equipados aqui.",
    "simulator.toast.attachIncompatible": "Acessório incompatível com esta arma ou slot.",
    "simulator.toast.cannotMove": "Não foi possível mover para esse slot.",
    "simulator.toast.cannotEquip": "Não foi possível equipar este acessório.",
    "simulator.toast.equipped": "{name} equipado.",
    "simulator.toast.unequipped": "{name} removido da arma.",
    "simulator.toast.nameRequired": "O nome do VIP é obrigatório para baixar a fatura.",
    "simulator.toast.minTotal": "O total do kit deve ser de pelo menos {min} para baixar a fatura.",
    "simulator.toast.invoiceDownloaded": "Fatura descarregada! Abre um ticket VIP no Discord e anexa o ficheiro.",
    "simulator.toast.invoiceFailed": "Não foi possível gerar a fatura. Tenta outra vez.",
    "simulator.toast.historyFailed":
        "Fatura descarregada, mas não foi possível guardar o histórico na base de dados.",
    "simulator.toast.alreadyInKit": "{name} já está no kit. Remove com × para trocar.",
    "simulator.toast.qtyUpdated": "{name}: quantidade atualizada para ×{qty}.",
    "simulator.toast.added": "{name} adicionado ao kit.",
    "simulator.toast.addFailed": "Não foi possível adicionar — kit cheio ou slot incompatível.",
    "simulator.persist.notConfigured": "Supabase não configurado.",

    // Colocação automática (catálogo)
    "simulator.place.generic": "Não foi possível adicionar este item ao kit.",
    "simulator.place.outfitEquipped":
        "Com um traje nos Equipáveis, não podes vestir mais peças de roupa. Move o traje para o inventário.",
    "simulator.place.armorFull": "Os 7 slots de Equipável estão cheios. Remove uma peça para adicionar outra.",
    "simulator.place.noArmorSlot": "Não há slot livre nos Equipáveis.",
    "simulator.place.fullTorsoTaken": "Inventário e cinto cheios, e o tronco nos Equipáveis já tem um item.",
    "simulator.place.fullWearOutfit":
        "Inventário e cinto cheios. Liberta um slot ou veste o traje no tronco (Equipável).",
    "simulator.place.noOutfitSlot": "Não há slot disponível para este traje.",
    "simulator.place.invBeltFull": "Inventário e cinto estão cheios.",
    "simulator.place.kitFull": "Kit cheio ou sem slot compatível.",

    // Regras de roupa
    "simulator.clothing.onlyWearable": "As roupas só podem ir para Equipável, não para inventário ou cinto.",
    "simulator.clothing.armorFull":
        "Os 7 slots de Equipável estão cheios. Remove uma peça ou usa um equipamento rápido.",
    "simulator.clothing.slotTaken":
        "Este slot de Equipável já está ocupado. Escolhe outro slot ou remove a peça actual.",
    "simulator.clothing.cannotPlace": "Não foi possível colocar nos Equipáveis.",
    "simulator.clothing.removeOthers":
        "Remove as outras peças dos Equipáveis antes de vestir o traje, ou coloca o traje no inventário.",
    "simulator.clothing.outfitTorsoOnly": "O traje só pode ser vestido no slot de tronco (Equipável).",
    "simulator.clothing.outfitBadSlot": "Este traje não pode ir para esse slot.",

    // Fatura (HTML exportado)
    "simulator.invoice.htmlLang": "pt-BR",
    "simulator.invoice.fileDefault": "vip-personalizado",
    "simulator.invoice.filePrefix": "pedido-vip",
    "simulator.invoice.emptyItems": "Nenhum item no kit",
    "simulator.invoice.openSteam": "Abrir perfil Steam",
    "simulator.invoice.player": "Jogador",
    "simulator.invoice.noBenefits": "Nenhum benefício extra selecionado.",
    "simulator.invoice.docTitle": "Pedido VIP — {name} | ZRS",
    "simulator.invoice.title": "Pedido VIP personalizado",
    "simulator.invoice.subtitle": "Resumo do kit e benefícios simulados — anexa este ficheiro ao ticket Discord.",
    "simulator.invoice.badge": "Simulador",
    "simulator.invoice.orderData": "Dados do pedido",
    "simulator.invoice.vipName": "Nome do VIP",
    "simulator.invoice.budget": "Budget (simulação)",
    "simulator.invoice.generatedAt": "Gerado em",
    "simulator.invoice.kitItems": "Itens do kit",
    "simulator.invoice.itemCount": ({ count }) => `${count} ${count === 1 ? "item" : "itens"}`,
    "simulator.invoice.colItem": "Item",
    "simulator.invoice.colQty": "Qtd.",
    "simulator.invoice.colUnit": "Valor / un.",
    "simulator.invoice.colSub": "Subtotal",
    "simulator.invoice.extraBenefits": "Benefícios extra",
    "simulator.invoice.selectedCount": "{count} selecionados",
    "simulator.invoice.financial": "Resumo financeiro",
    "simulator.invoice.kitSubtotal": "Subtotal do kit (itens)",
    "simulator.invoice.extras": "Extras (mochila e benefícios)",
    "simulator.invoice.total": "Total estimado",
    "simulator.invoice.negotiable": "O preço final é negociável com a equipa de admins após análise do pedido.",
    "simulator.invoice.nextStep": "Próximo passo — Discord",
    "simulator.invoice.step1": "Abre um ticket na categoria {vips} no servidor ZRS.",
    "simulator.invoice.step2": "Anexa este ficheiro HTML (ou imprime em PDF).",
    "simulator.invoice.step3": "Aguarda confirmação da equipa — o valor pode ser ajustado.",
    "simulator.invoice.footer": "ZRS — Zaralha Servers · Documento gerado pelo simulador VIP · {date}",
};

const en = {
    // Header / hero
    "simulator.back": "← Back to VIP plans",
    "simulator.headerSub": "Custom VIP simulator",
    "simulator.title": "Build your VIP [BETA]",
    "simulator.lead.p1":
        "Build your kit on a Rust-style grid: inventory, belt and gear. Click items to add them; drag inside the kit to rearrange. On weapons, ",
    "simulator.lead.mods": "Mods",
    "simulator.lead.or": " or ",
    "simulator.lead.dblClick": "double-click",
    "simulator.lead.p2": " opens the 3D view to equip attachments. Remove items only with ",
    "simulator.lead.p3": ". The final price is still ",
    "simulator.lead.negotiable": "negotiable with the admins",
    "simulator.lead.end": ".",
    "simulator.minNotice.strong": "Custom VIP from {amount}.",
    "simulator.minNotice.text": " We only accept requests with an estimated kit total equal to or above this amount.",
    "simulator.nameLabel": "VIP name",
    "simulator.namePlaceholder": "e.g. VIP Raid Night",

    // Tabs
    "simulator.tabs.aria": "Simulator section",
    "simulator.tabs.kit": "Kit",
    "simulator.tabs.benefits": "Benefits",

    // Workspace
    "simulator.workspace.title": "Workspace",
    "simulator.workspace.lead1":
        "Belt (weapons and consumables), 6×4 inventory and gear. Click to add; on weapons use ",
    "simulator.workspace.lead2": " or double-click for attachments (3D model on the MP5 and AK).",
    "simulator.belt.aria": "Belt",
    "simulator.belt.title": "Belt",
    "simulator.belt.meta": "6 slots",
    "simulator.inv.aria": "Inventory",
    "simulator.inv.title": "Inventory",
    "simulator.inv.meta": "6 × 4 slots",
    "simulator.equip.aria": "Clothing and armor",
    "simulator.equip.title": "Clothing + armor",
    "simulator.equip.meta": "Wearable",
    "simulator.armor.gridAria": "Wearables — 7 Rust-style slots",

    // Gear slots (accessibility)
    "simulator.armorSlot.armor-head": "Head",
    "simulator.armorSlot.armor-mask": "Face",
    "simulator.armorSlot.armor-chest": "Chest",
    "simulator.armorSlot.armor-belt": "Waist",
    "simulator.armorSlot.armor-hands": "Hands",
    "simulator.armorSlot.armor-legs": "Legs",
    "simulator.armorSlot.armor-feet": "Feet",
    "simulator.armorSlot.default": "Wearable",

    // Categories (folder → label)
    "simulator.categories": {
        Armadilhas: "Traps",
        Armas: "Weapons",
        Comida: "Food",
        Componentes: "Components",
        Construção: "Construction",
        Elétrica: "Electrical",
        Elétrico: "Electrical",
        Ferramentas: "Tools",
        Itens: "Items",
        Medicamentos: "Medical",
        Médico: "Medical",
        Munição: "Ammo",
        Outros: "Misc",
        Diversão: "Fun",
        Recursos: "Resources",
        Roupas: "Clothing",
        Veículos: "Vehicles",
        misc: "Misc",
    },

    // Available items
    "simulator.pool.all": "All",
    "simulator.pool.title": "Available items",
    "simulator.pool.hint":
        "This list always stays visible. Set the quantity before adding; if the item is already in the kit, the quantity is added to the same slot (after confirming). With a weapon in the kit, double-click it to equip attachments.",
    "simulator.pool.catsAria": "Item categories",
    "simulator.pool.emptyCatalog": "No items in the catalog for this category.",
    "simulator.pool.emptyCategory": "No items in this category. Pick another one or go back to \"All\".",

    // Item card
    "simulator.item.addTitleQty": "Add {name} to the kit (or add to the quantity if it's already there)",
    "simulator.item.addTitle": "Add {name} to the kit",
    "simulator.item.unit": "Unit: {price}",
    "simulator.item.noPrice": "No price set",
    "simulator.item.wearable": "Wearable",
    "simulator.item.outfitNote": "Inventory or chest (Wearable)",
    "simulator.item.qty": "Qty: {qty}",
    "simulator.item.sub": "Sub: {amount}",
    "simulator.item.remove": "Remove from kit",

    // Stepper
    "simulator.stepper.decrease": "Decrease",
    "simulator.stepper.quantity": "Quantity",
    "simulator.stepper.increase": "Increase",

    // Quick equip
    "simulator.quick.aria": "Quick equip sets",
    "simulator.quick.label": "Quick equip",
    "simulator.quick.title": "Equip set: {label}",

    // Weapons / attachments
    "simulator.weapon.hint": "{name} — double-click or use the Mods button for attachments",
    "simulator.weapon.modsAria": "Attachments on {name}",
    "simulator.weapon.modsTitle": "Equip attachments (sight, barrel, laser, magazine)",
    "simulator.weapon.mods": "Mods",
    "simulator.weapon.hasMods": "Has attachments",
    "simulator.wmod.slot.sight": "Sight",
    "simulator.wmod.slot.barrel": "Barrel",
    "simulator.wmod.slot.laser": "Laser",
    "simulator.wmod.slot.magazine": "Magazine",
    "simulator.wmod.poolEquippedTitle": "{name} — remove from this weapon only (stays in the list)",
    "simulator.wmod.poolEquipTitle": "Equip {name} on this weapon (the list keeps the item)",
    "simulator.wmod.equippedBadge": "Equipped",
    "simulator.wmod.slotFilledTitle": "{name} — click to remove",
    "simulator.wmod.slotEmptyTitle": "Empty {slot} slot",
    "simulator.wmod.desc3d": "3D model ({title}). Rotate and zoom; click an attachment to equip or remove it.",
    "simulator.wmod.descNo3d":
        "No 3D model for this weapon — showing the icon. Click an attachment to equip or remove it.",
    "simulator.wmod.equipped": "Equipped",
    "simulator.wmod.poolTitle": "Attachments (weapon mods)",
    "simulator.wmod.poolHint":
        "The list doesn't run out when you equip — you can use the same attachment on another weapon later.",
    "simulator.wmod.poolEmpty":
        "No compatible attachments in the list. Add sights, silencers, lasers or magazines from the Weapons category.",

    // Summary
    "simulator.summary.aria": "Order summary",
    "simulator.summary.title": "Summary",
    "simulator.summary.vipName": "VIP name",
    "simulator.summary.budget": "Budget (simulation)",
    "simulator.summary.budgetWarn": "Tier above the total — add items to the kit to reach it.",
    "simulator.summary.inv": "Inventory",
    "simulator.summary.belt": "Belt",
    "simulator.summary.gear": "Gear",
    "simulator.summary.itemsCount": ({ count }) => `${count} ${count === 1 ? "item" : "items"}`,
    "simulator.summary.piecesCount": ({ count }) => `${count} ${count === 1 ? "piece" : "pieces"}`,
    "simulator.summary.invoiceItems": "Invoice items",
    "simulator.summary.colName": "Name",
    "simulator.summary.colQty": "Qty",
    "simulator.summary.colUnit": "Price/unit",
    "simulator.summary.colSub": "Subtotal",
    "simulator.summary.noItems": "No items selected",
    "simulator.summary.benefits": "Selected benefits",
    "simulator.summary.none": "None",
    "simulator.summary.extras": "Extras (benefits)",
    "simulator.summary.total": "Estimated total",
    "simulator.summary.kitPlusBenefits": "Kit {kit} + benefits {extras}",
    "simulator.summary.budgetLine": "Budget (simulation): R$ {budget}",
    "simulator.summary.budgetBelow": " — tier below the kit total",
    "simulator.summary.missingMin": "{amount} short of the {min} minimum",
    "simulator.summary.finalPrice": "Final price: ",
    "simulator.summary.negotiable": "Negotiable with admins",
    "simulator.summary.download": "Download invoice",
    "simulator.summary.toDownload": "To download the invoice:",
    "simulator.summary.needName1": "Fill in the ",
    "simulator.summary.needName2": "VIP name",
    "simulator.summary.needName3": " at the top of the page (required).",
    "simulator.summary.needMin1": "The kit total must be at least ",
    "simulator.summary.needMin2": " ({amount} to go).",
    "simulator.summary.tierNote":
        "The budget tier (R$ {budget}) can differ from the total — that doesn't block the invoice.",
    "simulator.summary.hint1": "The ",
    "simulator.summary.hintInvoice": "invoice",
    "simulator.summary.hint2": " is downloaded to your computer. Then open a ticket in the ",
    "simulator.summary.hintVips": "VIPs",
    "simulator.summary.hint3": " category on Discord and attach the file.",
    "simulator.summary.success":
        "Invoice saved. Open Discord, create a VIP ticket and send the file so the admins can review your kit.",
    "simulator.summary.attachmentSuffix": "{name} (attachment)",

    // Discord button
    "simulator.discord.aria": "Open the ZRS Discord and create a ticket in the VIPs category",
    "simulator.discord.label": "Open a VIP ticket on Discord",
    "simulator.discord.sub": "Send the invoice you just downloaded",

    // Toasts / confirms
    "simulator.toast.presetNotFound": "Gear set not found.",
    "simulator.toast.presetMissing": "Gear applied, but some items are missing from the catalog: {items}",
    "simulator.toast.presetApplied": "Quick equip applied to all 7 slots.",
    "simulator.confirm.merge":
        "You already have \"{name}\" in the kit (×{qty}).\n\nAdding it will raise the inventory quantity to ×{newQty} — it won't take another slot.\n\nContinue?",
    "simulator.toast.onlyAttachments": "Only weapon attachments can be equipped here.",
    "simulator.toast.attachIncompatible": "This attachment doesn't fit this weapon or slot.",
    "simulator.toast.cannotMove": "Couldn't move it to that slot.",
    "simulator.toast.cannotEquip": "Couldn't equip this attachment.",
    "simulator.toast.equipped": "{name} equipped.",
    "simulator.toast.unequipped": "{name} removed from the weapon.",
    "simulator.toast.nameRequired": "A VIP name is required to download the invoice.",
    "simulator.toast.minTotal": "The kit total must be at least {min} to download the invoice.",
    "simulator.toast.invoiceDownloaded": "Invoice downloaded! Open a VIP ticket on Discord and attach the file.",
    "simulator.toast.invoiceFailed": "Couldn't generate the invoice. Please try again.",
    "simulator.toast.historyFailed": "Invoice downloaded, but we couldn't save the history to the database.",
    "simulator.toast.alreadyInKit": "{name} is already in the kit. Remove it with × to swap.",
    "simulator.toast.qtyUpdated": "{name}: quantity updated to ×{qty}.",
    "simulator.toast.added": "{name} added to the kit.",
    "simulator.toast.addFailed": "Couldn't add it — kit full or no compatible slot.",
    "simulator.persist.notConfigured": "Supabase is not configured.",

    // Auto placement (catalog)
    "simulator.place.generic": "Couldn't add this item to the kit.",
    "simulator.place.outfitEquipped":
        "With a suit in the Wearables, you can't put on more clothing. Move the suit to the inventory.",
    "simulator.place.armorFull": "All 7 Wearable slots are full. Remove a piece to add another.",
    "simulator.place.noArmorSlot": "No free Wearable slot.",
    "simulator.place.fullTorsoTaken": "Inventory and belt are full, and the Wearable chest slot is already taken.",
    "simulator.place.fullWearOutfit":
        "Inventory and belt are full. Free a slot or wear the suit in the chest slot (Wearable).",
    "simulator.place.noOutfitSlot": "No slot available for this suit.",
    "simulator.place.invBeltFull": "Inventory and belt are full.",
    "simulator.place.kitFull": "Kit full or no compatible slot.",

    // Clothing rules
    "simulator.clothing.onlyWearable": "Clothing can only go in the Wearable slots, not the inventory or belt.",
    "simulator.clothing.armorFull": "All 7 Wearable slots are full. Remove a piece or use a quick equip set.",
    "simulator.clothing.slotTaken":
        "This Wearable slot is already taken. Pick another slot or remove the current piece.",
    "simulator.clothing.cannotPlace": "Couldn't place it in the Wearables.",
    "simulator.clothing.removeOthers":
        "Remove the other Wearable pieces before putting on the suit, or place the suit in the inventory.",
    "simulator.clothing.outfitTorsoOnly": "The suit can only be worn in the chest slot (Wearable).",
    "simulator.clothing.outfitBadSlot": "This suit can't go in that slot.",

    // Invoice (exported HTML)
    "simulator.invoice.htmlLang": "en",
    "simulator.invoice.fileDefault": "custom-vip",
    "simulator.invoice.filePrefix": "vip-request",
    "simulator.invoice.emptyItems": "No items in the kit",
    "simulator.invoice.openSteam": "Open Steam profile",
    "simulator.invoice.player": "Player",
    "simulator.invoice.noBenefits": "No extra benefits selected.",
    "simulator.invoice.docTitle": "VIP request — {name} | ZRS",
    "simulator.invoice.title": "Custom VIP request",
    "simulator.invoice.subtitle": "Summary of the simulated kit and benefits — attach this file to your Discord ticket.",
    "simulator.invoice.badge": "Simulator",
    "simulator.invoice.orderData": "Request details",
    "simulator.invoice.vipName": "VIP name",
    "simulator.invoice.budget": "Budget (simulation)",
    "simulator.invoice.generatedAt": "Generated on",
    "simulator.invoice.kitItems": "Kit items",
    "simulator.invoice.itemCount": ({ count }) => `${count} ${count === 1 ? "item" : "items"}`,
    "simulator.invoice.colItem": "Item",
    "simulator.invoice.colQty": "Qty",
    "simulator.invoice.colUnit": "Price / unit",
    "simulator.invoice.colSub": "Subtotal",
    "simulator.invoice.extraBenefits": "Extra benefits",
    "simulator.invoice.selectedCount": "{count} selected",
    "simulator.invoice.financial": "Financial summary",
    "simulator.invoice.kitSubtotal": "Kit subtotal (items)",
    "simulator.invoice.extras": "Extras (backpack and benefits)",
    "simulator.invoice.total": "Estimated total",
    "simulator.invoice.negotiable": "The final price is negotiable with the admin team after reviewing the request.",
    "simulator.invoice.nextStep": "Next step — Discord",
    "simulator.invoice.step1": "Open a ticket in the {vips} category on the ZRS server.",
    "simulator.invoice.step2": "Attach this HTML file (or print it to PDF).",
    "simulator.invoice.step3": "Wait for the team to confirm — the price may be adjusted.",
    "simulator.invoice.footer": "ZRS — Zaralha Servers · Document generated by the VIP simulator · {date}",
};

export default { pt, en };
